import { connect } from 'react-redux';

import { userHasInstitutionLogin, userHasRegistration } from '../HeaderComponentSelectors';
import UnauthSiteNavigation from './UnauthSiteNavigation';

function mapStateToProps(state) {
  return {
    userHasInstitutionLogin: userHasInstitutionLogin(state),
    userHasRegistration: userHasRegistration(state),
  };
}

export default connect(mapStateToProps)(UnauthSiteNavigation);
